import { render, staticRenderFns } from "./product_note.vue?vue&type=template&id=40b507d7&scoped=true&"
import script from "./product_note.vue?vue&type=script&lang=js&"
export * from "./product_note.vue?vue&type=script&lang=js&"
import style0 from "./product_note.vue?vue&type=style&index=0&id=40b507d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b507d7",
  null
  
)

export default component.exports